function t(a) {
  return this.__data__.has(a);
}
var s = t;
export {
  s as default
};
//# sourceMappingURL=_stackHas.js.map
